var map = {
	"./countries/australia.svg": [
		2376,
		2376
	],
	"./countries/canada.svg": [
		87072,
		7072
	],
	"./countries/france.svg": [
		49323,
		9323
	],
	"./countries/germany.svg": [
		60493,
		493
	],
	"./countries/india.svg": [
		77187,
		7187
	],
	"./countries/ireland.svg": [
		53071,
		3071
	],
	"./countries/italy.svg": [
		20895,
		895
	],
	"./countries/japan.svg": [
		93858,
		3858
	],
	"./countries/netherlands.svg": [
		86534,
		6534
	],
	"./countries/new-zealand.svg": [
		59972,
		9972
	],
	"./countries/north-korea.svg": [
		32450,
		2450
	],
	"./countries/portugal.svg": [
		29468,
		9468
	],
	"./countries/singapore.svg": [
		68840,
		8840
	],
	"./countries/south-africa.svg": [
		55468,
		5468
	],
	"./countries/south-korea.svg": [
		13948,
		3948
	],
	"./countries/spain.svg": [
		99473,
		9473
	],
	"./countries/united-kingdom.svg": [
		33371,
		3371
	],
	"./countries/united-states-of-america.svg": [
		94703,
		4703
	],
	"./icon-add.svg": [
		76086,
		6086
	],
	"./icon-close.svg": [
		47487,
		7487
	],
	"./icon-error.svg": [
		69757,
		9757
	],
	"./icon-tick-outline.svg": [
		14451,
		4451
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 67930;
module.exports = webpackAsyncContext;